// Generated by Melange

import PlaybackPositionModuleCss from "./playbackPosition.module.css";
import * as Curry from "melange.js/curry.jsx";
import * as Shared__Duration from "./duration.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Stdlib__Result from "melange/result.jsx";
import * as StoreFx__RunAsync from "../storeFx/runAsync.jsx";
import * as StoreFx__SetCurrentTime from "../storeFx/setCurrentTime.jsx";
import * as Store__Context from "../store/context.jsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = PlaybackPositionModuleCss;

function PlaybackPosition(Props) {
  const buffered = Store__Context.useAppStore(function (state) {
    return state.player.buffered;
  });
  const currentTime = Store__Context.useAppStore(function (state) {
    return state.player.currentTime;
  });
  const duration = Store__Context.useAppStore(function (state) {
    return state.player.duration;
  });
  const runAsyncStoreFx = StoreFx__RunAsync.use(undefined);
  const match = React.useState(function () {
    return Stdlib__Fun.$$const(undefined, undefined);
  });
  const setHoverInfo = match[1];
  const hoverInfo = match[0];
  const clientXToTime = function (params) {
    return Math.max(0.0, Math.min(params.duration * params.x / params.width, params.duration));
  };
  const now = Stdlib__Option.value(Stdlib__Option.map((function (x) {
    return x.time;
  }), hoverInfo), currentTime);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        duration !== undefined ? JsxRuntime.jsxs(React.Fragment, {
            children: [
              buffered.map(function (param, index) {
                const start = param.start;
                const Key = String(index);
                return JsxRuntime.jsx("div", {
                  className: css.buffered,
                  style: Object.assign({}, {}, {
                    "--scale-x": String((param.end - start) / duration),
                    "--translate-x": String(100.0 * start / duration) + "%"
                  })
                }, Key);
              }),
              JsxRuntime.jsx("div", {
                className: css.position,
                style: Object.assign({}, {}, {
                  "--scale-x": currentTime / duration
                })
              })
            ]
          }) : null,
        JsxRuntime.jsx("span", {
          children: Shared__Duration.format(currentTime),
          className: css.currentTime
        }),
        hoverInfo !== undefined ? JsxRuntime.jsx("span", {
            children: Shared__Duration.format(hoverInfo.time),
            className: css.hoverTime,
            style: Object.assign({}, {}, {
              "--translate-x": String(hoverInfo.x) + "px"
            })
          }) : null,
        duration !== undefined ? JsxRuntime.jsx("span", {
            children: Shared__Duration.format(duration),
            className: css.duration
          }) : null
      ],
      className: css.inner
    }),
    "aria-label": "Playback position",
    "aria-valuemax": Stdlib__Option.value(duration, 0.0),
    "aria-valuenow": now,
    "aria-valuetext": Shared__Duration.format(now),
    className: css.root,
    role: "slider",
    tabIndex: 0,
    onMouseMove: (function ($$event) {
      Stdlib__Option.iter((function (duration) {
        const bcr = $$event.currentTarget.getBoundingClientRect();
        const x = $$event.clientX - bcr.left;
        requestAnimationFrame(function (param) {
          const width = bcr.width;
          const time = clientXToTime({
            duration: duration,
            x: x,
            width: width
          });
          const partial_arg = {
            x: x,
            time: time
          };
          Curry._1(setHoverInfo, (function (param) {
            return Stdlib__Fun.$$const(partial_arg, param);
          }));
        });
      }), duration);
    }),
    onMouseOut: (function (param) {
      requestAnimationFrame(function (param) {
        Curry._1(setHoverInfo, (function (param) {
          return Stdlib__Fun.$$const(undefined, param);
        }));
      });
    }),
    onMouseUp: (function ($$event) {
      Stdlib__Option.iter((function (duration) {
        requestAnimationFrame(function (param) {
          Curry._1(setHoverInfo, (function (param) {
            
          }));
        });
        const bcr = $$event.currentTarget.getBoundingClientRect();
        const width = bcr.width;
        const x = $$event.clientX - bcr.left;
        Curry._1(runAsyncStoreFx, StoreFx__SetCurrentTime.make(function (param) {
          return clientXToTime({
            duration: duration,
            x: x,
            width: width
          });
        })).then(function (result) {
          return Promise.resolve(Stdlib__Result.get_ok(result));
        });
      }), Stdlib__Option.bind(duration, (function (duration) {
        if ($$event.button === 0) {
          return duration;
        }
        
      })));
    })
  });
}

const make = PlaybackPosition;

export {
  make,
}
/* css Not a pure module */
